import SignUp from '../components/SignUp.js'

export default function Join() {
    return (
      <>
        <SignUp />
      </>
    );
  }